const state = {
  now: new Date()
}

let ticker = null

const actions = {
  startTicker: async ({ commit }) => {
    if (!ticker) {
      ticker = setInterval(() => {
        commit('SET_NOW')
      }, 1000)
    }
  },
  stopTicker: async ({ commit }) => {
    if (ticker) {
      clearInterval(ticker)
      ticker = null
    }
  }
}

const mutations = {
  SET_NOW: (state) => {
    state.now = new Date()
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
